var exports = {
  "Nr": "GuildTagCard.module__card___LVVjYW",
  "d5": "GuildTagCard.module__head___LVVjYW",
  "Kk": "GuildTagCard.module__icon___LVVjYW",
  "Qq": "GuildTagCard.module__text___LVVjYW",
  "DD": "GuildTagCard.module__title___LVVjYW",
  "_0": "GuildTagCard.module__detail___LVVjYW",
  "aK": "GuildTagCard.module__hint___LVVjYW",
  "Pz": "GuildTagCard.module__iconPlaceholder___LVVjYW",
  "IW": "GuildTagCard.module__titlePlaceholder___LVVjYW",
  "Kq": "GuildTagCard.module__profileCard___LVVjYW" + " " + "GuildTagCard.module__card___LVVjYW",
  "vK": "GuildTagCard.module__banner___LVVjYW",
  "_e": "GuildTagCard.module__bannerImage___LVVjYW",
  "ME": "GuildTagCard.module__profile___LVVjYW",
  "$": "GuildTagCard.module__titleRow___LVVjYW",
  "dJ": "GuildTagCard.module__stat___LVVjYW",
  "RS": "GuildTagCard.module__onlineDot___LVVjYW",
  "kq": "GuildTagCard.module__memberDot___LVVjYW",
  "h_": "GuildTagCard.module__description___LVVjYW",
  "_A": "GuildTagCard.module__tags___LVVjYW",
  "Tc": "GuildTagCard.module__tag___LVVjYW",
  "o1": "GuildTagCard.module__actions___LVVjYW",
};

module.exports = exports;
